<template>
  <b-tabs content-class="pt-1" fill>
    <!-- Onglet de téléchargement -->
    <b-tab active title="Sélectionner une signature">
      <b-col cols="12" class="mb-2">
        <div class="border rounded p-2">
          <b-media no-body vertical-align="center" class="flex-column flex-md-row">
            <b-media-aside>
              <b-img
                ref="refPreviewEl"
                :src="signatureImageUrl"
                height="110"
                width="170"
                class="rounded mr-2 mb-1 mb-md-0"
              />
            </b-media-aside>
            <b-media-body>
              <div class="d-inline-block">
                <small class="text-muted">Résolution d'image requise 150x200, taille de l'image 10mb (.jpg, .png, .jpeg)</small>
                <b-form-file ref="refInputEl" v-model="selectedFile" accept=".jpg, .png, .jpeg" placeholder="Choisir une signature" @change="onFileChange" title="signature" />
              </div>
            </b-media-body>
          </b-media>
        </div>
      </b-col>
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BMedia, BMediaBody, BFormFile, BMediaAside, BCol, BImg } from 'bootstrap-vue'
import { ref, watch, onMounted } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BTabs,
    BTab,
    BMedia,
    BMediaBody,
    BFormFile,
    BMediaAside,
    BCol,
    BImg,
  },
  props: {
    signature: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedFile: null,
      signatureImageUrl: null,
      //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    }
  },
  watch: {
    signature: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.signatureImageUrl = 'data:image/png;base64,' + newValue;
        }
      }
    }
  },
  methods: {

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        { position }
      );
    },
    // async onFileChange(event) {
    //   const file = event.target.files[0];
    //   if (file) {
    //     // Convertir le fichier en tableau de bytes
    //     const bytes = await this.readFileAsByteArray(file);
    //     // Mettre à jour l'image de prévisualisation
    //     this.signatureImageUrl = URL.createObjectURL(file);
    //     // Émettre le tableau de bytes
    //     this.$emit('inputImageRenderer', bytes);
    //   }
    // },
    async onFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      // Vérifier l'extension et la taille
      const allowedTypes = ['image/jpeg', 'image/png','image/jpg'];
      if (!allowedTypes.includes(file.type) || file.size > 10 * 1024 * 1024) {
        this.showToast('primary', 'top-right', 'Fichier invalide ! Veuillez choisir une image JPG ou PNG de moins de 10 Mo.');
        this.selectedFile = null;  return;
      }
 
      // Nettoyer l'ancienne URL pour éviter les fuites mémoire
      if (this.signatureImageUrl) {
        URL.revokeObjectURL(this.signatureImageUrl);
      }
 
      // Générer l'aperçu
      this.signatureImageUrl = URL.createObjectURL(file);
      // Lire le fichier en tant que tableau de bytes
      const bytes = await this.readFileAsByteArray(file);
      // Envoyer les données pour traitement sécurisé côté serveur
      this.$emit('inputImageRenderer', bytes);
    }
  },
    readFileAsByteArray(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const arrayBuffer = event.target.result;
          const bytes = new Uint8Array(arrayBuffer);
          resolve(bytes);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
      });
    },
  },
}
</script>
